import { useEditorClass } from '@tunasong/editor'
import type { Chat, Persisted } from '@tunasong/schemas'
import type { FC } from 'react'
import ChatFeedItem from './chat-feed-item.js'
import { useChat } from './chat.hook.js'
import { CommentMenu } from './comment-menu.js'
import { CommentContent } from './comment-content.js'
import styles from './chat-thread.module.css'

export interface ChatThreadProps {
  /** The thread: a block's child chat */
  element: Persisted<Chat>
  className?: string
}

/**
 * A block's comments, read-only, for an anchored group in the sidebar Chat (chat makeover M3, #2718). Replies are
 * written in the block's popup. Every comment shows: resolving is the whole thread's, from its header (chat tasks
 * M3, GH #2796). A plain list: the feed's scroll-to-last would make every group fight over the scroll position.
 */
export const ChatThread: FC<ChatThreadProps> = props => {
  const { element, className } = props
  const ChatEditor = useEditorClass('ChatEditor')
  const { comments } = useChat({ element, pageSize: 25 })

  if (comments.length === 0) {
    return null
  }

  return (
    <ol className={className ?? styles.thread}>
      {comments.map(comment => (
        <li key={comment.id}>
          <ChatFeedItem
            ref={null}
            item={{
              ...comment,
              content: (
                <CommentContent comment={comment}>
                  <ChatEditor readOnly={true} autoFocus={false} element={comment} />
                </CommentContent>
              ),
              actions: <CommentMenu comment={comment} />,
            }}
          />
        </li>
      ))}
    </ol>
  )
}
